import { NgModule } from '@angular/core';

import { GCADAIfOnDomDirective } from '@GCADA/directives/GCADA-if-on-dom/GCADA-if-on-dom.directive';
import { GCADAInnerScrollDirective } from '@GCADA/directives/GCADA-inner-scroll/GCADA-inner-scroll.directive';
import { GCADAPerfectScrollbarDirective } from '@GCADA/directives/GCADA-perfect-scrollbar/GCADA-perfect-scrollbar.directive';
import { GCADAMatSidenavHelperDirective, GCADAMatSidenavTogglerDirective } from '@GCADA/directives/GCADA-mat-sidenav/GCADA-mat-sidenav.directive';

@NgModule({
    declarations: [
        GCADAIfOnDomDirective,
        GCADAInnerScrollDirective,
        GCADAMatSidenavHelperDirective,
        GCADAMatSidenavTogglerDirective,
        GCADAPerfectScrollbarDirective
    ],
    imports     : [],
    exports     : [
        GCADAIfOnDomDirective,
        GCADAInnerScrollDirective,
        GCADAMatSidenavHelperDirective,
        GCADAMatSidenavTogglerDirective,
        GCADAPerfectScrollbarDirective
    ]
})
export class GCADADirectivesModule
{
}
